// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"1402d2e2","633":"fb6ed499","652":"b3e1c5c3"}[chunkId] + ".chunk.js";
};